module.exports = __webpack_public_path__ + "img/blacklist.424e492c.png";